import { render } from "./b2b.vue?vue&type=template&id=1463f089"
import script from "./b2b.vue?vue&type=script&lang=js"
export * from "./b2b.vue?vue&type=script&lang=js"

import "./b2b.vue?vue&type=style&index=0&id=1463f089&lang=css"

import exportComponent from "/Users/nick/programming/mimi/IFA_loud/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__